import React, { useState } from 'react';
import { Field, Control, Icon, Button, File } from 'Components/common/bulma';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faTimes, faPaperclip, faSpinner, faCheck } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';

const FileWithErrors = ({
  label,
  input,
  error,
  showErrors,
  id,
  onUploadFile = () => {},
}) => {
  const [randKey, setRandKey] = useState(Date.now());
  const [file, setFile] = useState(null);
  const [isUploading, setIsLoading] = useState(false);
  const [isUploaded, setIsUploaded] = useState(false);


  const onRemoveFile = () => {
    setFile(null);
    setRandKey(Date.now());
    setIsUploaded(false)
  };

  const onChangeFile = (e) => {
    if (e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  }

  const onUpload = async () => {
    if (file) {
      console.log(file)
      setIsLoading(true)
      try {
        await onUploadFile({ content: file, name: file.name });
        setIsLoading(false)
        onRemoveFile()
      } catch (error) {
        setIsLoading(false)
        onRemoveFile()
        throw error
      }
      
    }
  }

  return (
    <Field>
      <label className="label">{label}</label>
      <Control>
        <File name right>
          <File.Label>
            <File.Input
              key={randKey}
              name={input.name}
              accept={input.accept}
              onChange={onChangeFile}
            />
            <File.Cta>
              <File.Icon>
                <FontAwesomeIcon icon={faPaperclip} />
              </File.Icon>
              <File.Label as='span'>
              </File.Label>
            </File.Cta>
            <File.Name>
              {file?.name || input.value}
            </File.Name>
          </File.Label>
          <Button type="button" onClick={onUpload} disabled={!file || isUploading}>
            <Icon>
              {isUploaded && <FontAwesomeIcon icon={faCheck} className="has-text-success" />}
              {isUploading && <FontAwesomeIcon className="fa-spin" icon={faSpinner} />}
              {(!isUploading && !isUploaded) && <FontAwesomeIcon icon={faUpload} />}
            </Icon>
          </Button>
          <Button type="button" onClick={onRemoveFile} disabled={!file}>
            <Icon>
              <FontAwesomeIcon icon={faTimes} />
            </Icon>
          </Button>
        </File>
      </Control>
      {(error && showErrors) && <p className="has-text-danger help">{error}</p>}
    </Field>
  );
};

FileWithErrors.propTypes = {
  label: PropTypes.string,
  isUploading: PropTypes.bool,
  onUploadFile: PropTypes.func,
};

export default FileWithErrors;
